import e from"@emotion/styled";import{setColor as o,setFontSize as n}from"../../utils/generateStyles.js";const r=e.a`
  label: link-text;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  ${t=>o("blue-DEFAULT","color")};
  ${t=>n(t.contentFontSize)};
  ${t=>t.hasDecoration&&{textDecoration:"underline",textUnderlineOffset:"3px",textDecorationColor:"#004C6A"}}
`;export{r as default};
